import { render, staticRenderFns } from "./learningRecord.vue?vue&type=template&id=5fb02541&scoped=true"
import script from "./learningRecord.vue?vue&type=script&lang=js"
export * from "./learningRecord.vue?vue&type=script&lang=js"
import style0 from "./learningRecord.vue?vue&type=style&index=0&id=5fb02541&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb02541",
  null
  
)

export default component.exports